import {fetchWrapper} from './fetchWrapper'

export const createOCAPIFetch =
    (commerceAPIConfig, endpointsPath) => async (method, args, body) => {
        const host = commerceAPIConfig.apiHost
            ? `https://${commerceAPIConfig.apiHost}`
            : commerceAPIConfig.commerceAPI.proxyPathOcapi

        const {siteId} = commerceAPIConfig.commerceAPI.parameters

        const endPoint = `${host}/s/${siteId}/dw/shop/v24_5`

        const apiUrl = `${endPoint}/${endpointsPath}`

        const options = {
            method,
            headers: {
                ...args[0].headers,
                'Content-Type': 'application/json'
            },
            ...(body && {
                body: JSON.stringify(body)
            })
        }

        let response = await fetchWrapper(apiUrl, options)

        const jsonResponse = await response
        return jsonResponse
    }
